import { render, staticRenderFns } from "./nodeSuggest.vue?vue&type=template&id=9700f5a0&"
import script from "./nodeSuggest.vue?vue&type=script&lang=ts&"
export * from "./nodeSuggest.vue?vue&type=script&lang=ts&"
import style0 from "./nodeSuggest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports